import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-50 border-t border-gray-200 text-right">
      <div className="px-3 sm:px-3 lg:px-3 py-2">
        <div className="text-right">
          <p className="text-sm text-gray-500 font-poppins"> 2026 © All Right Reserved</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
